import { useEffect } from "react";

/** El nombre que ya lleva la pestaña en index.html; va detrás de cada título. */
export const TITULO_BASE = "Centro Educativo Tecnológico";

/**
 * Pone el título de la pestaña según la pantalla (WCAG 2.4.2).
 *
 * Es una SPA con HashRouter: sin esto todas las pantallas se llamaban igual, y
 * quien navega con lector de pantalla —o con veinte pestañas abiertas en la
 * computadora de la biblioteca— no tenía forma de saber dónde estaba. El
 * nombre de la pantalla va primero porque es lo que se lee (y lo que cabe en
 * la pestaña); el del centro, detrás.
 *
 * `Hero` lo llama con su propio título, así que las pantallas con cabecera de
 * sala no tienen que hacer nada. Las que no tienen Hero (detalle de materia,
 * de agencia, de universidad, el login…) lo llaman ellas.
 *
 * Sin título (null/undefined) NO toca nada, a propósito: así una pantalla que
 * todavía carga, o que solo quiere nombrar un sub-estado (el juego abierto en
 * STEM), puede llamarlo siempre sin pisar el título que puso su Hero.
 */
export function useTitulo(titulo: string | null | undefined) {
  useEffect(() => {
    if (titulo) document.title = `${titulo} · ${TITULO_BASE}`;
  }, [titulo]);
}
